module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Contents#r_idParaDest-12"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_c('b', [_vm._v("5")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Contents#r_idParaDest-12"
    }
  }, [_vm._v("Honey and Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("UGUSTA IS WOKEN FROM A DEEP SLEEP BY A KNOCK AT THE")]), _vm._v(" front door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Shit. That was fast. How did he find me?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She slips off the sofa. Heart racing. Eyes darting to Rose’s china cabinet. She moves quickly toward it. Grabs a porcelain figurine. The sharpest one she can find. Purple unicorn. Levi lolls on his back. Legs spread-eagle. Great guard dog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Augusta tiptoes across the foyer and peers through the peephole. The floorboards wince. Not Lars. Some guy in a wrinkled gray suit. Carrying a briefcase. Wiping his sweaty forehead on his sleeve. Bible salesman written all over him. She opens the door. His eyes flit to the unicorn. He clears his throat and smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You must be Rose’s great-granddaughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Augusta nods. Definitely a Bible salesman. She places the figurine on the hall tree in the entryway. Hanging from the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("hooks of the tree are an umbrella and Rose’s blue hat with a feather that sweeps across the rim. Old lady hat.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rose isn’t here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I know. I’m Mr. Honey. Rose’s lawyer? Executor of her estate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus suddenly remembers calling him the day before. He said he’d be in the neighborhood tomorrow and would pop by first thing. And it’s now tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Levi staggers from the living room, slightly punch-drunk. Stretching his hind legs out behind him, one at a time, like a ballet dancer. He nudges Augusta’s calf and yawns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My deepest condolences for your loss. There are just a few documents that need signing and then I’ll leave you be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus almost laughs when he says this. "), _c('i', [_vm._v("Leave you be.")]), _vm._v(" She’s all too familiar with being left. But just being and not being told how to be or where to be. That’s uncharted waters for Gus. She lets Mr. Honey in through the front foyer of Rose’s house, all the while wondering what on earth she’ll do when he leaves her be.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_t"
  }, [_vm._v("S"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("LIPPING INTO A HOT BUBBLE BATH LATER THAT NIGHT,")]), _vm._v(" G"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("US")]), _vm._v(" tries hard to let herself be. Too hard. She gives up and simply floats, warm in her watery porcelain vessel. Eyes, ears, and nose just above the surface like the portholes of a sinking ship. Gus lets the day’s event replay across her closed eyelids like a bad sitcom, starting with the image of Mr. Honey flaring his nostrils as he enters the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tenacious brussels sprout aroma looms large. She opens the back door to let fresh air in through the screen door "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("behind it. Levi circles. Mr. Honey checks her ID then pulls some documents from his briefcase. Levi whines. Augusta clues in. She reaches for the latch on the screen door, but the dog can’t wait. He lunges through the screen, breaking the seal. First patch of brown grass he hits, his hind leg’s up and he’s peeing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus signs on the "), _c('i', [_vm._v("X")]), _vm._v("s of forms while Mr. Honey avoids eye contact. He doesn’t want any unseemly tears or embarrassing hand-holding. When they’re all done with the paperwork, he hands her a set of keys like she’s just won a new car on "), _c('i', [_vm._v("The Price Is Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This one’s for the Buick. This one’s for the exterior garage door. There’s two for the front door, one dead bolt, one main lock. And this one’s for the back door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He assures her that Miss Santos turned over all her keys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry, she won’t be causing any more trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaves the Proof of Death Certificate on the kitchen table. Says Gus will need it for when she goes to the bank. Says he’s taken the liberty of arranging an appointment for her with someone named Trish Virtue at Scotiabank. Rose’s bank. For later that day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrinks when Gus asks, “How did Rose die?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your great-grandmother passed peacefully in her sleep with her loving dog by her side.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sounds like an obituary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two weeks ago. It’s all on the certificate. She was cremated and interred at Beechwood Cemetery as per her wishes. She had a prepaid plot and headstone. She didn’t want a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("service. And we weren’t sure how to contact you. Miss Santos only yesterday managed to find your number so, at the time, it seemed prudent not to wait. No fuss, no muss, you see. And that’s that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the trouble with Miss Santos?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh that. She made some sort of scene at the bank when she tried to access Rose’s bank account. She even called my office and was quite rude to my secretary. She was ranting about a promise made to her by Rose. I told her I knew nothing of promises, only last wishes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Honey seems proud that he got the better of Miss Santos. Like he beat her at a game of chess. Gus is glad when he packs up to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floating in the lukewarm bubbles now, Gus can still see the strange little man walking briskly away from Rose’s house. The back of his neck glistened with sweat. She thinks about broken promises and the mark they can leave on your heart. She knows the feeling well. Gus imagines the shame Miss Santos must have felt as she scrambled after the broken pieces of that promise made to her by Rose. A promise that wasn’t just broken. It was, in fact, a lie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The images fast-forward and Gus sees herself sitting in the red leather chair across from Miss Virtue in a small, glass-walled office in Scotiabank. After brief "), _c('i', [_vm._v("hello")]), _vm._v("s, "), _c('i', [_vm._v("how are you")]), _vm._v("s, and "), _c('i', [_vm._v("so sorry")]), _vm._v("s, Miss Virtue yo-yos from her office to a printer room down the hall. There and back, there and back, her heels clicking on the polished floors. Her manicured nails tapping on the computer keyboard. A small run visible in her nylons just above the right ankle. A slight twitch at the corner of her mouth as she "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("slowly turns the computer monitor to show Gus the amount left in Rose’s estate account after legal fees and bank charges and outstanding debts and property taxes are paid.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That amount now dances across Augusta’s eyelids like a flashing neon ticker in Times Square announcing the entirety of her inheritance to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twenty-two dollars and sixty-eight cents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Thanks for nothing, Great-Grammie Rose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Piling on the bad news, Miss Virtue saves the best for last. A few years ago, Rose refinanced the house so she could continue to live in it. Something called a reverse mortgage. Bottom line, the bank wants that loan repaid and Augusta neither qualifies for a new mortgage nor has the money to pay it off. It’s due in ninety days or the house belongs to the bank. Miss Virtue hands Augusta the business card of her friend, a real estate agent. The banker knows it before Gus does. The house must be sold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Augusta sinks underwater. A soft booming throbs at her temples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boom. She could go back to Lars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boom. She could run away and start a new life in Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boom. She could lock the doors and never go outside again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus comes up for air and knows what she has to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tomorrow, she’ll call Miss Virtue’s real estate agent friend and put the house up for sale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Levi rests his chin on the edge of the tub. Gus lifts her wet hand and gently rubs the velvety soft tip of one of his ears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You love it here too, don’t you, dog?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("Gus closes her eyes and tries to be. Just for a moment. She almost does it. Almost believes that her last living relative actually left her a rambling old house that is hers to keep forever. A beautiful home with a pretty picture window and a deep front porch. The kind of house she and her mother used to dream of living in one day. Together.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03eaf6dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062948052_Chapter_5.vue
// module id = 87
// module chunks = 0